import {MaintenanceScheduleAffectedChecksFormValues} from "@/pages/maintenance/maintenance-create/tabs/affected-checks/MaintenanceScheduleAffectedChecksTab.types.ts";
import {MaintenanceScheduleGeneralFormValues} from "@/pages/maintenance/maintenance-create/tabs/general/MaintenanceScheduleGeneralTab.types.ts";
import {MaintenanceScheduleNotificationsFormValues} from "@/pages/maintenance/maintenance-create/tabs/notifications/MaintenanceScheduleNotificationsTab.types.ts";

export enum MaintenanceScheduleTabs {
  GENERAL = "general",
  AFFECTED_CHECKS = "affected-checks",
  NOTIFICATIONS = "notifications",
}

export type MaintenanceScheduleFormData = MaintenanceScheduleGeneralFormValues &
  MaintenanceScheduleAffectedChecksFormValues &
  MaintenanceScheduleNotificationsFormValues;
